@use '../../styling/colors.scss' as *;

.PinStart {
  fill: $color-primary-green;
}

.PinEnd {
  fill: $color-secondary-purple;
}

.PinPath {
  fill: $color-primary-purple;
}
